import styles from './styles.module.scss';
import React, { memo, useMemo } from 'react';
import { Animation, Image, Slider } from '@starsoft/common/components';

function HomeProvidersCards() {
  const Providers = useMemo(
    () =>
      Array.from({ length: 9 }).map((_, index) => (
        <Image
          height={75}
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/providers/${index}.svg`}
          alt={`provider-image-${index}`}
          key={`provider-image-${index}`}
          className={styles.container__cards}
        />
      )),
    [],
  );
  return (
    <React.Fragment>
      <div className="mobile_only">
        <div className={styles.container}>
          <Slider hideButtons>{Providers}</Slider>
        </div>
      </div>
      <div className="desktop_only">
        <Animation type="fadeInDown">
          <div className={styles.container}>{Providers}</div>
        </Animation>
      </div>
    </React.Fragment>
  );
}

export default memo(HomeProvidersCards);
